// cross icon 

export default function CrossIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path d="M12.4638 11.0564L7.62746 6.35061L12.3333 1.51427C12.5932 1.24717 12.5873 0.819965 12.3202 0.560072C12.0531 0.300178 11.6259 0.306021 11.366 0.573121L6.66023 5.40943L1.8239 0.703598C1.55677 0.443727 1.12957 0.449569 0.869676 0.71667C0.609783 0.983771 0.615625 1.41098 0.882726 1.67087L5.71904 6.37668L1.01322 11.213C0.75333 11.4801 0.759172 11.9073 1.02627 12.1672C1.29337 12.4271 1.72058 12.4212 1.98047 12.1541L6.68629 7.31783L11.5226 12.0236C11.7897 12.2835 12.2169 12.2777 12.4768 12.0106C12.7367 11.7435 12.7309 11.3163 12.4638 11.0564Z" fill="black"/>
        </svg>
    );
}